import { Outlet } from 'react-router';
import { ActiveShopProvider } from 'providers/ActiveShopProvider';

export default function StandaloneFrame() {
  return (
    <ActiveShopProvider>
      <Outlet />
    </ActiveShopProvider>
  );
}
